"use strict";

var _interopRequireWildcard = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _stackRoute = _interopRequireWildcard(require("@/api/business/trace/stackRoute"));
var _dialog = _interopRequireDefault(require("./dialog"));
var _wlList = _interopRequireDefault(require("./wl-list/wl-list.vue"));
var _NodeContent = require("./NodeContent");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * @Author: zzy
 * @Date: 2022-12-15 09:33:21
 * @Desc: 普通节点内容
 */
var _default = exports.default = {
  name: 'SFCNodeContent',
  components: {
    Dialog: _dialog.default,
    FlowList: _wlList.default
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      activeName: 'artificialTrace',
      paginationObj: {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 15, 20],
        total: 0
      },
      apiPaginationObj: [],
      loading: false,
      form: {},
      queryNodeParam: _NodeContent.queryNodeParamData,
      listOptions: _NodeContent.listOptionsData,
      showNodeTypePopover: false,
      clickTimeout: null,
      isClickInside: false,
      outerVisible: false,
      innerVisible: false,
      title: '序列号列表',
      openType: 'view',
      gridData: [],
      apiGridData: [],
      innerGridData: [],
      innerTabelData: {}
    };
  },
  watch: {
    showNodeTypePopover: function showNodeTypePopover(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          _this.setNodeTypePopoverStyle();
        });
      } else {
        setTimeout(function () {
          _this.resetNodeTypePopoverStyle();
        }, 300);
      }
    },
    'data.apiList': {
      immediate: true,
      handler: function handler(newVal) {
        if (Array.isArray(newVal)) {
          this.apiPaginationObj = newVal.map(function () {
            return {
              currentPage: 1,
              pageSize: 10,
              pageSizes: [10, 15, 20],
              total: 0
            };
          });
        }
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener('click', this.closeDialog);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.closeDialog);
  },
  methods: {
    tabsClick: function tabsClick(tab) {
      var paneName = tab.paneName;
      if (paneName === 'artificialTrace') {
        if (this.gridData.length > 0) {
          this.form.traceModeName = this.gridData[0].traceModeName;
        }
      } else {
        var index = parseInt(paneName.split('_')[1]);
        if (this.apiGridData[index] && this.apiGridData[index].length > 0) {
          this.form.traceModeName = this.apiGridData[index][0].traceModeName;
        }
      }
    },
    closeEvent: function closeEvent() {
      this.paginationObj = {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 15, 20],
        total: 0
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      // 改变每页显示的条数
      this.paginationObj.pageSize = val;
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.paginationObj.currentPage = 1;
      this.getNodeData();
    },
    apiHandleSizeChange: function apiHandleSizeChange(index, val) {
      // 改变对应页签每页显示的条数
      this.apiPaginationObj[index].pageSize = val;
      // 改变每页显示的条数时，将页码显示到第一页
      this.apiPaginationObj[index].currentPage = 1;
      this.getNodeData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      // 改变默认的页数
      this.paginationObj.currentPage = val;
      this.getNodeData();
    },
    apiHandleCurrentChange: function apiHandleCurrentChange(index, val) {
      // 改变对应页签默认的页数
      this.apiPaginationObj[index].currentPage = val;
      this.getNodeData();
    },
    handleClick: function handleClick(row) {
      this.innerVisible = true;
      this.innerGridData = row.productStationItemList;
      if (this.innerGridData.length > 0) {
        this.innerTabelData = {
          stationCode: this.innerGridData[0].stationCode,
          stationName: this.innerGridData[0].stationName,
          traceModeName: this.innerGridData[0].traceModeName,
          sequence: this.innerGridData[0].sequence
        };
      }
    },
    apiHandleClick: function apiHandleClick(row, index) {
      var _this2 = this;
      var reqData = {
        stationId: row.stationId,
        sequence: row.sequence
      };
      (0, _stackRoute.getSeqDetail)(reqData).then(function (res) {
        _this2.innerGridData = res.data;
      });
      this.innerVisible = true;
      if (this.apiGridData[index] && this.apiGridData[index].length > 0) {
        this.form.traceModeName = this.apiGridData[index][0].traceModeName;
      }
      if (this.innerGridData.length > 0) {
        this.innerTabelData = {
          stationCode: this.innerGridData[0].stationCode,
          stationName: this.innerGridData[0].stationName,
          traceModeName: this.innerGridData[0].traceModeName,
          sequence: this.innerGridData[0].sequence
        };
      }
    },
    operateNode: function operateNode(e) {
      var temp;
      if (this.$$isEmpty(e.menuPath)) {
        temp = "/trace/traceOperation/station-trace/dpClTrace/".concat(e.nodeDataList.routeAddress);
      } else {
        temp = "/trace/traceOperation/station-trace/".concat(e.menuPath, "/").concat(e.nodeDataList.routeAddress);
      }
      this.$router.push(temp);
    },
    getInfoNode: function getInfoNode(e) {
      this.outerVisible = true;
      this.form = {
        id: e.id,
        stationCode: e.nodeDataList.stationCode,
        stationName: e.nodeDataList.stationName,
        traceModeName: e.nodeDataList.traceModeName,
        startTime: e.startTime,
        endTime: e.endTime
      };
      this.getNodeData();
    },
    getNodeData: function getNodeData() {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var queryNodeParam;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this3.loading = true;
              queryNodeParam = {
                sortOrder: "desc",
                sortColumn: "createTime",
                conditionLink: "AND",
                pageNum: _this3.paginationObj.currentPage,
                pageSize: _this3.paginationObj.pageSize,
                staticConditions: [],
                conditions: [{
                  column: "stationDeployId",
                  exp: "=",
                  value: _this3.form.id
                }, {
                  column: "collect_time",
                  exp: ">=",
                  value: _this3.form.startTime
                }, {
                  column: "collect_time",
                  exp: "<=",
                  value: _this3.form.endTime
                }]
              };
              _stackRoute.default.getFlowltemData(queryNodeParam).then(function (res) {
                if (res.code === 200) {
                  _this3.loading = false;
                  _this3.gridData = res.rows;
                  _this3.paginationObj.total = res.total;
                }
              });
              // 动态获取 API 采集数据
              if (Array.isArray(_this3.data.apiList)) {
                _this3.data.apiList.forEach(function (_, index) {
                  // API 采集请求参数
                  var apiQueryNodeParam = {
                    sortOrder: "desc",
                    sortColumn: "createTime",
                    conditionLink: "AND",
                    pageNum: _this3.apiPaginationObj[index].currentPage,
                    pageSize: _this3.apiPaginationObj[index].pageSize,
                    staticConditions: [],
                    conditions: [{
                      column: "stationDeployId",
                      exp: "=",
                      value: _.id // 使用当前 API 项的 id
                    }, {
                      column: "collect_time",
                      exp: ">=",
                      value: _this3.form.startTime
                    }, {
                      column: "collect_time",
                      exp: "<=",
                      value: _this3.form.endTime
                    }]
                  };
                  _stackRoute.default.getApiFlowltemData(apiQueryNodeParam).then(function (res) {
                    if (res.code === 200) {
                      _this3.loading = false;
                      // this.apiGridData[index] = res.rows;
                      _this3.$set(_this3.apiGridData, index, res.rows);
                      _this3.apiPaginationObj[index].total = res.total;
                    }
                  });
                });
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    setNodeTypePopoverStyle: function setNodeTypePopoverStyle() {
      var el = this.$refs.nodeTypePopover;
      if (!el) {
        return;
      }
      var elWidth = el.offsetWidth;
      var elHeight = el.offsetHeight;
      var _el$getBoundingClient = el.getBoundingClientRect(),
        left = _el$getBoundingClient.left,
        top = _el$getBoundingClient.top;
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var style = {};
      style[top + elHeight > windowHeight ? 'bottom' : 'top'] = 0;
      style[left + elWidth > windowWidth ? 'right' : 'left'] = 42 + 'px';
      this.nodeTypePopoverStyle = style;
    },
    resetNodeTypePopoverStyle: function resetNodeTypePopoverStyle() {
      this.nodeTypePopoverStyle = {
        left: '42px',
        top: 0
      };
    },
    openDialog: function openDialog() {
      // popup弹窗
      // this.isClickInside = true;
      // if (!this.showNodeTypePopover) {
      //   this.showNodeTypePopover = true;
      // }
    },
    openInnerDialog: function openInnerDialog() {
      this.innerVisible = true;
    },
    closeDialog: function closeDialog() {
      this.showNodeTypePopover = false;
      this.isClickInside = false;
    },
    handlePopoverClick: function handlePopoverClick(e) {
      e.stopPropagation();
    },
    onMouseenter: function onMouseenter() {
      // this.showNodeTypePopover = true;
    },
    onMouseleave: function onMouseleave() {
      if (!this.isClickInside) {
        // this.showNodeTypePopover = false;
      }
    }
  }
};